import styled from '@emotion/styled';
import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { lazy, Suspense, type ComponentProps } from 'react';

import { Logo } from '../../Logo/Logo';

const LogoContainer = styled.div`
	--dimension: 70px;
	min-inline-size: var(--dimension);
	min-block-size: var(--dimension);
	block-size: var(--dimension);
	inline-size: var(--dimension);
	display: flex;
	align-items: center;
	justify-content: center;
	clip-path: inset(17%);
`;

const LazyAnimatedGhostLogo = lazy(() =>
	import('./LazyAnimatedGhostLogo').then((module) => ({ default: module.AnimatedGhostLogo })),
);

export const HalloweenLogo = observer(function HalloweenLogo(props: ComponentProps<typeof Logo>) {
	return (
		<Tooltip
			{...{
				title: 'Happy Halloween! 👻',
				placement: 'right',
				children: (
					<Logo
						{...{
							children: (
								<LogoContainer>
									<Suspense {...{ fallback: null }}>
										<LazyAnimatedGhostLogo />
									</Suspense>
								</LogoContainer>
							),
							...props,
						}}
					/>
				),
			}}
		/>
	);
});
